import axios from "axios";
import React, { useEffect, useState } from "react";
import Compfooter from "./Compfooter";
import { useParams } from "react-router-dom";
import Pembayaran2 from "../../pages/Pembayaran2";
import { Button, Modal, Form } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Compfoto from "./Compfoto";
import Compwasit from "./Compwasit";
import Combola from "./Combola";
import Comprompi from "./Compromi";

export default function Compmain() {
  const urlapi = process.env.REACT_APP_BASE_URL;
  const [wasit, setWasit] = useState([]);
  const [video, setVideo] = useState([]);
  const [foto, setFoto] = useState([]);
  const [bola, setBola] = useState([]);
  const [rompi, setRompi] = useState([]);
  const [idwasit, setIdwasit] = useState("");
  const [idvideo, setIdvideo] = useState("");
  const [idfoto, setIdfoto] = useState("");
  const [idrompi, setIdrompi] = useState("");
  const [idbola, setIdbola] = useState("");
  const [hargawasit, setHargawasit] = useState(0);
  const [hargavideo, setHargavideo] = useState(0);
  const [hargafoto, setHargafoto] = useState(0);
  const [hargarompi, setHargarompi] = useState(0);
  const [hargabola, setHargabola] = useState(0);
  const [jambooking, setJambooking] = useState([]);
  const [hargabooking, setHargabooking] = useState(0);
  const [pagewasit, setPagewasit] = useState(false);
  const [pagevideo, setPagevideo] = useState(false);
  const [pagefoto, setPagefoto] = useState(true);
  const [pagerompi, setPagerompi] = useState(false);
  const [pagebola, setPagebola] = useState(false);
  const [lapangan, setLapangan] = useState("");
  const [sistempembayaran, setSistempembayaran] = useState("");
  const [namateam, setNamateam] = useState("");
  const [wa, setWa] = useState("");
  const [status, setStaus] = useState("false");
  const [selectedItems, setSelectedItems] = useState([]);
  const [jmldata, setJmldata] = useState(0);
  const [showconfirm, setShowconfirm] = useState(false);
  const [setujui, setSetujui] = useState(false);
  const [showpay, setShowpay] = useState(false);

  const handleCloseconfirm = () => setShowconfirm(false);
  const handleShowconfirm = () => setShowconfirm(true);

  const handleLanjutkan = () => {
    setShowconfirm(false);
    setSetujui(false);
    setShowpay(true);
  };


  const formatrupiah = (numb) => {
    const format = numb.toString().split("").reverse().join("");
    const convert = format.match(/\d{1,3}/g);
    const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
    return rupiah;
  };

  const totalharga =
    Number(hargabooking) +
    Number(hargavideo) +
    Number(hargawasit) +
    Number(hargafoto) +
    Number(hargarompi) +
    Number(hargabola);

  const { idlap, idjam, itemjam, tgl } = useParams();

  const getwasit = async () => {
    try {
      const response = await axios.get(urlapi + "Wasit");
      setWasit(response.data);
    } catch (error) { }
  };

  const getbola = async () => {
    try {
      const response = await axios.get(urlapi + "Bola");
      setBola(response.data);
      // console.log(response.data);
    } catch (error) { }
  };

  const getrompi = async () => {
    try {
      const response = await axios.get(urlapi + "Rompi");
      setRompi(response.data);
    } catch (error) { }
  };

  const getvideo = async () => {
    try {
      const response = await axios.get(urlapi + "Videografer");
      // console.log(response.data);
      setVideo(response.data);
    } catch (error) { }
  };

  const getfoto = async () => {
    try {
      const response = await axios.get(urlapi + "Fotografer");
      setFoto(response.data);
    } catch (error) { }
  };

  const getdatajam = async () => {
    try {
      const response = await axios.get(urlapi + "Jambookingbaru?id=" + itemjam);
      setJambooking(response.data);
      setHargabooking(response.data.total_harga);
    } catch (error) { }
  };

  const getlapangan = async () => {
    try {
      const response = await axios.get(urlapi + "Lapangan?id=" + idlap);
      setLapangan(response.data.lapangan);
    } catch (error) { }
  };

  const handlewasit = (harga, checked) => {
    if (checked == false) {
      setHargawasit(Number(hargawasit) - Number(harga));
    } else {
      setHargawasit(Number(hargawasit) + Number(harga));
    }

  };

  const handlevideo = async (id) => {
    if (id == 0) {
      setHargavideo(0);
      setIdvideo("");
    } else {
      // console.log(id);
      gethargavideo(id);
      setIdvideo(id);
    }
  };

  const handlefoto = (harga, checked) => {
    if (checked == false) {
      setHargafoto(Number(hargafoto) - Number(harga));
    } else {
      setHargafoto(Number(hargafoto) + Number(harga));
    }
  };

  const handlerompi = (harga, checked) => {
    if (checked) {
      setHargarompi(Number(hargarompi) + Number(harga))
    } else {
      setHargarompi(Number(hargarompi) - Number(harga));
    }
  };

  const handlebola = (harga, checked) => {
    if (checked) {
      setHargabola(Number(hargabola) + Number(harga))
    } else {
      setHargabola(Number(hargabola) - Number(harga));
    }
  };

  const gethargawasit = async (id) => {
    try {
      const response = await axios.get(urlapi + "Wasit?id=" + id);
      setHargawasit(response.data.harga);
    } catch (error) { }
  };

  const gethargavideo = async (id) => {
    try {
      const response = await axios.get(urlapi + "Videografer?id=" + id);
      setHargavideo(response.data.harga);
    } catch (error) { }
  };

  const gethargafoto = async (id) => {
    try {
      const response = await axios.get(urlapi + "Fotografer?id=" + id);
      setHargafoto(response.data.harga);
    } catch (error) { }
  };

  const gethargarompi = async (id) => {
    try {
      const response = await axios.get(urlapi + "Rompi?id=" + id);
      setHargarompi(response.data.harga);
    } catch (error) { }
  };

  const gethargabola = async (id) => {
    try {
      const response = await axios.get(urlapi + "Bola?id=" + id);
      setHargabola(response.data.harga);
    } catch (error) { }
  };

  const cekbooking = async () => {
    try {
      const response = await axios.get(
        urlapi +
        "Cekbookinglapanganterbaru?idlap=" +
        idlap +
        "&&idjam=" +
        idjam +
        "&&tgl=" +
        tgl
      );
      setStaus("true");
    } catch (error) {
      setStaus("false");
    }
  };

  const hapusItem = (id, tanggal) => {
    const storedData = JSON.parse(localStorage.getItem('selectedItems')) || [];
    // Filter data untuk menghapus item dengan id tertentu
    const updatedData = storedData.filter((item) => item.id !== id || item.tanggal !== tanggal);
    // Simpan kembali data yang telah diperbarui ke localStorage
    localStorage.setItem('selectedItems', JSON.stringify(updatedData));
    setSelectedItems(updatedData)
    toast.success("Jam booking berhasil di hapus !", {
      position: toast.POSITION.TOP_CENTER,
    });

    const items = JSON.parse(localStorage.getItem('selectedItems')) || [];
    const jumlahData = items.length;
    setJmldata(jumlahData);
  }

  const totalhargabooking = () => {
    const storedData = JSON.parse(localStorage.getItem('selectedItems')) || [];
    const totalHarga = storedData.reduce((total, item) => {
      return total + parseInt(item.harga_diskon, 10); // Pastikan harga diubah menjadi angka
    }, 0);
    return totalHarga;
  };

  const totalhargaall = totalhargabooking() + Number(hargafoto) + Number(hargawasit) + Number(hargabola) + Number(hargarompi);


  useEffect(() => {
    setSelectedItems(JSON.parse(localStorage.getItem('selectedItems')))
    const items = JSON.parse(localStorage.getItem('selectedItems')) || [];
    const jumlahData = items.length;
    setJmldata(jumlahData);
    getrompi();
    getfoto();
    getwasit();
    getvideo();
    getbola();
    getdatajam();
    getlapangan();
  }, []);
  return (
    <div style={{ minHeight: "100vh" }} id="pagecheckout">
      <a href="#pagecheckout" id="buttonklik" style={{ display: "none" }}>
        KLIK
      </a>
      <div className="container">
        <br />
        <div className="checkout-hero mt-5">
          <div className="checkout-hero-icon">
            <i className="fas fa-shopping-cart"></i>
          </div>
          <div className="checkout-hero-text">
            <h5 className="fw-bold mb-1">Halaman Checkout</h5>
            <small>
              Anda dapat menambahkan layanan wasit, fotografer, videografer,
              rompi dan bola untuk booking lapangan anda
            </small>
          </div>
        </div>
        <hr />

        {status == "true" ? <></> : <></>}

        <div className="card checkout-schedule-card">
          <div className="card-body">
            <div className="schedule-title">
              <span className="schedule-title-icon">
                <i className="fas fa-calendar-days"></i>
              </span>
              Jadwal Booking yang Anda Pilih
            </div>

            <div class="alert alert-danger d-flex align-items-start gap-2 schedule-alert" role="alert">
              <i
                className="fas fa-warning"
                style={{ fontSize: "1.4rem", lineHeight: 1.3 }}
              ></i>
              <div>
                <strong className="d-block mb-1">PERHATIAN</strong>
                <small className="fw-bold">
                  Jadwal booking yang sudah di booking
                  tidak dapat dibatalkan atau diubah. Pastikan Anda memilih
                  tanggal dan waktu dengan teliti sebelum melakukan
                  booking.
                </small>
              </div>
            </div>

            {selectedItems.map((data, index) => {
              return (
                <div key={index}>
                  <div className="booking-item">
                    <div className="booking-item-header">
                      <div className="booking-item-info">
                        <span className="booking-time">
                          <i className="fas fa-clock"></i> {data.jam_mulai} - {data.jam_berakhir}
                        </span>
                        <span className="booking-date">
                          <i className="fas fa-calendar-day"></i> {data.tanggal}
                        </span>
                        <span className="booking-field">
                          <i className="fas fa-futbol"></i> {data.nama_lapangan}
                        </span>
                      </div>
                      <div className="booking-item-actions">
                        <span className="booking-price">
                          <i className="fas fa-coins"></i> {formatrupiah(data.harga_diskon)}
                        </span>
                        <span onClick={() => hapusItem(data.id, data.tanggal)} className="booking-delete">
                          <i className="fas fa-trash-alt"></i>
                        </span>
                      </div>
                    </div>
                    <div className="booking-item-body">
                      <Compfoto sendhargafoto={handlefoto} jmljam={jmldata} indexfoto={index} jammulai={data.jam_mulai} tanggal={data.tanggal} />
                      <Compwasit sendhargawasit={handlewasit} jmljam={jmldata} indexwasit={index} />
                      <Combola sendhargabola={handlebola} jmljam={jmldata} indexbola={index} />
                      <Comprompi sendhargarompi={handlerompi} jmljam={jmldata} indexrompi={index} />
                    </div>
                  </div>
                </div>
              )
            })}

          </div>
        </div>



        <div className="payment-info-card">
          <div className="payment-info-header">
            <div className="payment-info-icon">
              <i className="fas fa-university"></i>
            </div>
            <div>
              <h6 className="mb-1 fw-bold text-white">Informasi Pembayaran</h6>
              <small className="text-white-50">
                Pembayaran via Transfer Bank
              </small>
            </div>
          </div>
          <div className="payment-info-body">
            <div className="bank-detail">
              <div>
                <small className="bank-label">BANK BCA</small>
                <div className="bank-number fw-bold">
                  <i className="fas fa-credit-card"></i> 6475383951
                </div>
              </div>
              <div className="bank-holder">
                <small className="bank-label">Atas Nama</small>
                <div className="fw-bold">Pendy Or Handoko</div>
              </div>
            </div>
            <div className="payment-rules">
              <div className="rule-item">
                <i className="fas fa-exclamation-circle"></i>
                <span>
                  Booking lapangan wajib membayar <b>DP 50%</b> dari total harga
                </span>
              </div>
              <div className="rule-item">
                <i className="fas fa-clock"></i>
                <span>
                  Pelunasan wajib <b>H-1 (1 hari)</b> sebelum jadwal main
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="container">
        <div className="card checkout-form-card">
          <div className="card-body">
            <div className="checkout-form-title">
              <i className="fas fa-file-invoice-dollar"></i>
              Detail Pembayaran
            </div>
            <div className="row g-4">
              <div className="form-group col-md-6">
                <label className="checkout-label">
                  Lapangan
                </label>
                <div className="checkout-input-wrapper">
                  <input
                    type="text"
                    value={lapangan}
                    className="checkout-input fw-bold"
                    readOnly
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <label className="checkout-label">
                  Harga Lapangan
                </label>
                <div className="checkout-input-wrapper price-input">
                  <span className="currency-prefix">Rp</span>
                  <input
                    type="text"
                    value={totalhargaall.toLocaleString("id-ID")}
                    className="checkout-input fw-bold"
                    placeholder="0"
                    readOnly
                  />
                </div>
              </div>

              <div className="form-group col-md-6">
                <label className="checkout-label">
                  Metode Pembayaran
                </label>
                <div className="payment-options">
                  <label
                    className={`payment-option ${sistempembayaran === "Lunas" ? "active" : ""}`}
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      onClick={() => setSistempembayaran("Lunas")}
                    />
                    <div className="payment-option-icon">
                      <i className="fas fa-check-double"></i>
                    </div>
                    <div className="payment-option-text">
                      <span className="fw-bold">Lunas</span>
                      <small>Bayar {formatrupiah(totalhargaall)}</small>
                    </div>
                    <div className="payment-option-check">
                      <i className="fas fa-check-circle"></i>
                    </div>
                  </label>
                  <label
                    className={`payment-option ${sistempembayaran === "Dp" ? "active" : ""}`}
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      onClick={() => setSistempembayaran("Dp")}
                    />
                    <div className="payment-option-icon">
                      <i className="fas fa-percent"></i>
                    </div>
                    <div className="payment-option-text">
                      <span className="fw-bold">DP 50%</span>
                      <small>
                        Bayar {formatrupiah(Math.ceil(totalhargaall / 2))}
                      </small>
                    </div>
                    <div className="payment-option-check">
                      <i className="fas fa-check-circle"></i>
                    </div>
                  </label>
                </div>
              </div>

              <div className="form-group col-md-6">
                <label className="checkout-label">
                  Jumlah Transfer
                </label>
                <div className="checkout-input-wrapper price-input">
                  <span className="currency-prefix">Rp</span>
                  <input
                    type="text"
                    className="checkout-input fw-bold transfer-amount"
                    required=""
                    readOnly
                    value={
                      sistempembayaran == "Dp"
                        ? Math.ceil(totalhargaall / 2).toLocaleString("id-ID")
                        : totalhargaall.toLocaleString("id-ID")
                    }
                  />
                </div>
                <small className="transfer-hint">
                  <i className="fas fa-info-circle"></i>{" "}
                  {sistempembayaran == "Dp"
                    ? "Transfer DP 50% dari total pembayaran"
                    : "Transfer total pembayaran secara lunas"}
                </small>
              </div>

              <div className="form-group col-md-6">
                <label className="checkout-label">
                  Nama Team
                </label>
                <div className="checkout-input-wrapper">
                  <input
                    type="text"
                    className="checkout-input"
                    required=""
                    placeholder="Contoh: Sinar FC"
                    value={namateam}
                    onChange={(e) => setNamateam(e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group col-md-6">
                <label className="checkout-label">
                  No Whatsapp
                </label>
                <div className="checkout-input-wrapper">
                  <span className="input-prefix">
                    <i className="fab fa-whatsapp"></i>
                  </span>
                  <input
                    type="number"
                    className="checkout-input"
                    required=""
                    placeholder="08xxxxxxxx"
                    value={wa}
                    onChange={(e) => setWa(e.target.value)}
                  />
                </div>
                <small className="whatsapp-hint">
                  <i className="fas fa-bell"></i> Pastikan nomor aktif untuk
                  menerima notifikasi pembayaran
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <div className="mt-5">
        <div className="card fixed-bottom" style={{ border: "none" }}>
          <div className="card-body">
            <div className="container">
              <div className="d-flex justify-content-between">
                <div>
                  <label className="fw-bold" style={{ color: "#2b2e5a" }}>
                    Total : {formatrupiah(totalhargaall)}
                  </label>
                </div>
                <div>
                  {wa == "" || sistempembayaran == "" || namateam == "" ? (
                    <>
                      <Button
                        variant="btn rounded-pill disabled"
                        style={{ backgroundColor: "#2b2e5a", color: "white" }}
                      >
                        Bayar sekarang
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="btn rounded-pill"
                        onClick={handleShowconfirm}
                        style={{ backgroundColor: "#2b2e5a", color: "white" }}
                      >
                        Bayar sekarang
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Compfooter
          hargalap={hargabooking}
          wasit={hargawasit}
          video={hargavideo}
          lapangan={lapangan}
          team={namateam}
          wa={wa}
          pembayaran={sistempembayaran}
        /> */}
      </div>

      <Pembayaran2
        idlapangan={idlap}
        lapangan={lapangan}
        harga={totalhargabooking()}
        namateam={namateam}
        jambooking={idjam}
        wa={wa}
        tgl={tgl}
        totalharga={totalhargaall}
        wasit={idwasit}
        video={idvideo}
        foto={idfoto}
        rompi={idrompi}
        bola={idbola}
        sistempembayaran={sistempembayaran}
        item={selectedItems}
        showpay={showpay}
      />

      <Modal
        show={showconfirm}
        onHide={handleCloseconfirm}
        centered
        size="lg"
        className="confirm-booking-modal"
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#2b2e5a",
            color: "#fff",
            borderBottom: "none",
          }}
        >
          <Modal.Title style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
            <i className="fas fa-clipboard-check me-2"></i>
            Konfirmasi Booking Anda
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
          <div
            className="alert alert-info border-0 py-2 fw-bold"
            style={{ fontSize: "0.8rem" }}
          >
            <i className="fas fa-info-circle me-1"></i>
            Mohon periksa kembali detail booking anda di bawah ini sebelum melakukan pembayaran. Jadwal yang sudah di booking tidak dapat di ubah setelah melakukan pembayaran
          </div>

          {selectedItems.map((data, index) => (
            <div
              key={index}
              className="card border-0 shadow-sm mb-2"
              style={{ borderRadius: "10px", overflow: "hidden" }}
            >
              <div
                className="d-flex align-items-center px-3 py-2 justify-content-between"
                style={{ backgroundColor: "#f1f3fa", borderBottom: "1px solid #e9ecf5" }}
              >
                <small
                  className="fw-bold"
                  style={{ color: "#2b2e5a", fontSize: "0.8rem" }}
                >
                  <i className="fas fa-futbol me-1"></i>
                  {data.nama_lapangan}
                </small>
                <span
                  className="badge rounded-pill text-white"
                  style={{ backgroundColor: "#2b2e5a", fontSize: "0.7rem" }}
                >
                  #{index + 1}
                </span>
              </div>
              <div className="px-3 py-2" style={{ backgroundColor: "#fff" }}>
                <div className="row gx-2 gy-1">
                  <div className="col-6">
                    <div style={{ fontSize: "0.7rem", color: "#8a8f9e" }}>
                      Tanggal
                    </div>
                    <div
                      className="fw-bold"
                      style={{ color: "#2b2e5a", fontSize: "0.85rem" }}
                    >
                      <i className="fas fa-calendar-day me-1"></i>
                      {data.tanggal}
                    </div>
                  </div>
                  <div className="col-6">
                    <div style={{ fontSize: "0.7rem", color: "#8a8f9e" }}>
                      Jam
                    </div>
                    <div
                      className="fw-bold"
                      style={{ color: "#2b2e5a", fontSize: "0.85rem" }}
                    >
                      <i className="fas fa-clock me-1"></i>
                      {data.jam_mulai} - {data.jam_berakhir}
                    </div>
                  </div>
                </div>
                <div className="mt-1 pt-1" style={{ borderTop: "1px dashed #e9ecf5" }}>
                  <div style={{ fontSize: "0.7rem", color: "#8a8f9e" }}>
                    Harga Booking
                  </div>
                  <div
                    className="fw-bold"
                    style={{ color: "#28a745", fontSize: "0.85rem" }}
                  >
                    <i className="fas fa-coins me-1"></i>
                    {formatrupiah(data.harga_diskon)}
                  </div>
                </div>
                <div className="mt-1 pt-1" style={{ borderTop: "1px dashed #e9ecf5" }}>
                  <div style={{ fontSize: "0.7rem", color: "#8a8f9e" }}>
                    Layanan yang dipilih
                  </div>
                  <div className="d-flex flex-wrap gap-1 mt-1">
                    {data.idfoto ? (
                      <span className="badge bg-primary" style={{ fontSize: "0.7rem" }}>
                        <i className="fas fa-camera me-1"></i>Fotografer
                      </span>
                    ) : (
                      <></>
                    )}
                    {data.idwasit ? (
                      <span className="badge bg-success" style={{ fontSize: "0.7rem" }}>
                        <i className="fas fa-whistle me-1"></i>Wasit
                      </span>
                    ) : (
                      <></>
                    )}
                    {data.idbola ? (
                      <span className="badge bg-warning text-dark" style={{ fontSize: "0.7rem" }}>
                        <i className="fas fa-futbol me-1"></i>Bola
                      </span>
                    ) : (
                      <></>
                    )}
                    {data.idrompi ? (
                      <span className="badge bg-danger" style={{ fontSize: "0.7rem" }}>
                        <i className="fas fa-tshirt me-1"></i>Rompi
                      </span>
                    ) : (
                      <></>
                    )}
                    {!data.idfoto &&
                      !data.idwasit &&
                      !data.idbola &&
                      !data.idrompi ? (
                      <span className="badge bg-secondary" style={{ fontSize: "0.7rem" }}>
                        <i className="fas fa-minus me-1"></i>Tidak ada layanan tambahan
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="agreement-box">
            <Form.Check
              type="checkbox"
              className="agreement-check"
              label={
                <span className="agreement-text">
                  Setujui jika tanggal dan jam yang anda pilih sudah benar
                </span>
              }
              checked={setujui}
              onChange={(e) => setSetujui(e.target.checked)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none" }}>
          <Button
            variant="outline-secondary"
            onClick={handleCloseconfirm}
            className="rounded-pill px-4"
            style={{ fontSize: "0.85rem" }}
          >
            Batal
          </Button>
          <Button
            variant="btn rounded-pill px-4"
            disabled={!setujui}
            onClick={handleLanjutkan}
            style={{
              backgroundColor: "#2b2e5a",
              color: "white",
              fontSize: "0.85rem",
            }}
          >
            <i className="fas fa-arrow-right me-1"></i>
            Lanjutkan
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </div >
  );
}
